import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import MessageSpacer from 'Organisms/MessageList/MessageListItem/MessageSpacer';
import MessageLeftGutter from 'Organisms/MessageList/MessageListItem/MessageLeftGutter';
import MessageHeader from 'Organisms/MessageList/MessageListItem/MessageHeader';
import { FDBox, FDStack } from '@facet-wealth/design';
import MessageWithThreadRoutingContent
  from 'Organisms/MessageList/MessageListItem/LeftBorderedMessageListItem/MessageWithThreadRoutingContent';
import { LeftBorderedBox } from 'Packages/FacetDesign/Components/Experimental/LeftBorderedBox';
import RichTextDisplayPicker from 'Organisms/MessageList/MessageListItem/MessageContent/Content/RichTextDisplayPicker';
import { dataAttrs } from 'Helpers/Testing';
import {
  AttachmentsSectionRebranded,
} from 'Components/ComponentLibrary/Components/Uncategorized/AttachmentsSectionRebranded';

const LeftBorderedMessageListItem = ({ messageResource, onLoadComplete }) => {
  const MessageContentComponent = messageResource.withRelationship(
    fr.relationships.threadRoutingDetails.name,
    () => <MessageWithThreadRoutingContent messageResource={messageResource} onLoadComplete={onLoadComplete} />,
    () => (
      <RichTextDisplayPicker
        resource={messageResource}
        content={messageResource.attr('content')}
      />),
  );

  return (
    <FDStack direction={'column'} spacing={2} {...dataAttrs('left-bordered-message-list-item')}>
      <MessageSpacer />
      <FDBox paddingX={2}>
        <LeftBorderedBox backgroundColor={'subtleLightest'} borderColor={'secondary'}>
          <FDStack direction={'column'} spacing={1} paddingY={3} paddingX={4} width={'100%'}>
            <FDStack direction={'row'} alignItems={'center'}>
              <MessageLeftGutter
                messageResource={messageResource}
                showAvatar
              />
              <MessageHeader messageResource={messageResource} />
            </FDStack>
            {MessageContentComponent}
            {messageResource?.attr('attachments') && (
              <AttachmentsSectionRebranded
                attachmentsCollection={messageResource?.attr('attachments')}
                eventCategory={'Messages'}
              />
            )}
          </FDStack>
        </LeftBorderedBox>
      </FDBox>
    </FDStack>
  );
};

LeftBorderedMessageListItem.defaultProps = {
  onLoadComplete: () => {},
};

LeftBorderedMessageListItem.propTypes = {
  messageResource: PropTypes.instanceOf(fr.Resource).isRequired,
  onLoadComplete: PropTypes.func,
};

export default LeftBorderedMessageListItem;
